export default __webpack_public_path__ + "static/landscape-8bit-7a53606b659a120b6a4c26c12a023bb9.jpg";